import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';
import {getImage} from '@dazn/lp-web/src/utils';
import {buttonProxy} from './button.proxy';

function convertToUTCString(dateString: string): string {
    const date = new Date(dateString);
    return date.toISOString();
}
export function countdownProxy(component: any) {
    const countdownData = component?.fields?.entries[0]?.fields;
    const buttonData = buttonProxy(countdownData?.button?.fields);

    return {
        backgroundColor: countdownData?.backgroundColor,
        targetTime: convertToUTCString(countdownData?.date),
        title: countdownData?.title,
        price: countdownData?.price,
        badgeText: countdownData?.badge,
        units: countdownData?.units,
        componentType: ComponentTypes.COUNTDOWN,
        backgroundImage: getImage(countdownData?.backgroundImage),
        hideCountdownZero: countdownData?.hideCountdownZero,
        button: buttonData,
        billingPeriod: buttonData?.billingPeriod,
        entitlementSetId: buttonData?.entitlementSetId,
        buttonStartIcon: getImage(buttonData?.startIcon)
    };
}
